var a = (r, g, t) => new Promise((c, s) => {
  var i = (e) => {
    try {
      o(t.next(e));
    } catch (n) {
      s(n);
    }
  }, p = (e) => {
    try {
      o(t.throw(e));
    } catch (n) {
      s(n);
    }
  }, o = (e) => e.done ? c(e.value) : Promise.resolve(e.value).then(i, p);
  o((t = t.apply(r, g)).next());
});
import { Debug as l } from "./debug-logger.es.js";
import { DefaultEnvironment as k } from "./defaults.es.js";
import { Environment as E } from "./environment.es.js";
import { getJSONTagContent as P, getMatchingTags as d } from "./meta-tag-helper.es.js";
import { featureFlag as C, onActivePage as D } from "./feature-flag.es.js";
import { getLinkClickEventProperties as T, getLinkParentId as b } from "./cdp-formatter.es.js";
const m = () => a(void 0, null, function* () {
  try {
    return (yield fetch("/mp/status")).status === 200;
  } catch (r) {
    return console.error("Error checking user login status:", r), !1;
  }
});
export {
  l as Debug,
  k as DefaultEnvironment,
  E as Environment,
  C as featureFlag,
  P as getJSONTagContent,
  T as getLinkClickEventProperties,
  b as getLinkParentId,
  d as getMatchingTags,
  m as isUserLoggedIn,
  D as onActivePage
};
